<style lang="less" scoped>
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }
  .ulivebus-container {
    background-color: #f8ecf1;
  }
  .in-sec {
    width: 1200px; margin: 0 auto;
    height: 1245px; position: relative;
  }
  .car {
    position: absolute; top: 235px; left: 250px; z-index: 1;
    width: 469px; height: 408px; background: url(~@/assets/car-2-1.png) no-repeat;
  }
  .satellite {
    position: absolute; top: 118px; left: 629px; z-index: 1;
    width: 184px; height: 120px; background: url(~@/assets/satellite-1.png) no-repeat;
  }
  .signal-1 {
    position: absolute; top: 189px; left: 526px; z-index: 3;
    width: 114px; height: 130px; background: url(~@/assets/signal-1.png) no-repeat;
    animation-name: play;
    animation-duration: 2s;
    animation-delay: 1.9s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
  .signal-2 {
    position: absolute; top: 193px; left: 574px; z-index: 2;
    width: 72px; height: 82px; background: url(~@/assets/signal-2.png) no-repeat;
    animation-name: play;
    animation-duration: 2s;
    animation-delay: 1.7s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
  .signal-3 {
    position: absolute; top: 200px; left: 617px; z-index: 1;
    width: 32px; height: 37px; background: url(~@/assets/signal-3.png) no-repeat;
    animation-name: play;
    animation-duration: 2s;
    animation-delay: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
  @keyframes play {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .road {
    position: absolute; bottom: 0; left: 170px; z-index: 0;
    width: 990px; height: 724px; background: url(~@/assets/road-1.png) no-repeat;
  }
  .line {
    position: absolute; bottom: 309px; left: 328px; z-index: 0;
    width: 344px; height: 295px; background: url(~@/assets/line-2.png) no-repeat;
  }
  .car-1 {
    position: absolute; bottom: 260px; left: 453px; z-index: 0;
    width: 92px; height: 75px; background: url(~@/assets/car-4.png) no-repeat;
  }
  .sign {
    position: absolute; bottom: 325px; left: 468px; z-index: 1;
    width: 72px; height: 82px; background: url(~@/assets/sign-2.png) no-repeat;
  }
  h2 {
    font-size: 54px; color: #1170fe;
    padding-top: 112px; position: relative; z-index: 1;
    &.type-2 {
      color: #29d0d6; padding-top: 340px; padding-bottom: 24px;
    }
    span {
      display: block; font-size: 20px; font-family: 'NotoSansKR_L';
      color: #222224; padding-top: 9px;
    }
  }
  ul {
    background-color: #41486d; width: 370px;
    color: #fff; padding: 39px 0 39px 5px; border-radius: 20px;
    position: absolute; right: 0; top: 100px;
    li {
      line-height: 44px;
      span {
        display: inline-block; padding: 0 36px;
        color: #64a2fe; font-family: 'DINPro-B';
      }
    }
  }
  dl {
    margin: 0; padding: 0; position: relative; z-index: 1;
    dt {
      font-size: 18px; line-height: 36px; background-color: #49c0c4;
      border-radius: 18px; display: inline-block; color: #fff;
      padding: 0 24px; margin: 40px 0 12px 0;
    }
    dd {
      margin: 0; color: #222224; font-size: 15px; line-height: 28px;
      padding-left: 10px; position: relative;
      &::before {
        content: ''; position: absolute; width: 3px; height: 3px;
        background-color: #4ad4d9; border-radius: 100%; left: 0; top: 13px;
      }
    }
  }
  .building-1 {
    position: absolute; bottom: 250px; left: 329px; z-index: 0;
    width: 59px; height: 80px; background: url(~@/assets/building-2.png) no-repeat;
    &.type-1 {
      left: 807px; bottom: 362px;
    }
  }
  .building-2 {
    position: absolute; bottom: 220px; left: 657px; z-index: 0;
    width: 193px; height: 157px; background: url(~@/assets/building-3.png) no-repeat;
  }
  .building-3 {
    position: absolute; bottom: 372px; left: 367px; z-index: 0;
    width: 186px; height: 143px; background: url(~@/assets/building-4.png) no-repeat;
  }
  .time-1 {
    position: absolute; bottom: 562px; left: 390px; z-index: 0;
    width: 58px; height: 70px; background: url(~@/assets/time-1.png) no-repeat;
  }
  .time-2 {
    position: absolute; bottom: 451px; left: 586px; z-index: 0;
    width: 51px; height: 75px; background: url(~@/assets/time-2.png) no-repeat;
  }
  .media {
    right: 0; z-index: 3;
  }

  .animate {
    transition-delay: .5s;
    transition-duration: .25s;
    transition-timing-function: ease-in;
  }
  .animate-1 { transition-delay: .3s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-2 { transition-delay: .5s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-3 { transition-delay: .6s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-4 { transition-delay: .7s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-5 { transition-delay: .8s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-6 { transition-delay: .9s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-7 { transition-delay: 1s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-8 { transition-delay: .8s; transition-duration: .4s; transition-timing-function: ease-in; }

  .slide-down {
    opacity: 0;
    transform: translateY(-50px);
  }
  .slide-down.animate-active {
    opacity: 1;
    transform: translateY(0);
  }

  .slide-car {
    opacity: 0;
    transform: translate(-150px,-50px);
  }
  .slide-car.animate-active {
    opacity: 1;
    transform: translate(0,0);
  }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: auto; height: 780px;
    }
    .road {
      bottom: 0; left: 0;
      width: 495px; height: 361px;
      background-size: cover;
      // .abs-lcenter;
    }
    .line {
      bottom: 153px; left: 79px;
      width: 172px; height: 147px; background-size: cover;
    }
    .car {
      top: 88px; left: 10px;
      width: 234px; height: 204px;
      background-size: cover;
      z-index: 0;
      transform: scale(-1, 1);
    }
    .slide-car {
      transform: scale(-1, 1) translate(-150px,-50px);
    }
    .slide-car.animate-active {
      transform: scale(-1, 1) translate(0,0);
    }
    .satellite {
      top: 45px; left: 10px;
      width: 92px; height: 60px;
      background-size: cover;
      transform: scale(-1, 1);
    }
    .signal-1 {
      top: 81px; left: 92px; z-index: 3;
      width: 57px; height: 65px; background-size: cover;
      transform: scale(-1, 1);
    }
    .signal-2 {
      top: 84px; left: 90px; z-index: 2;
      width: 36px; height: 41px; background-size: cover;
      transform: scale(-1, 1);
    }
    .signal-3 {
      top: 88px; left: 90px; z-index: 1;
      width: 16px; height: 18px; background-size: cover;
      transform: scale(-1, 1);
    }
    .car-1 {
      bottom: 134px; left: 150px;
      width: 46px; height: 37px; background-size: cover;
    }
    .sign {
      position: absolute; bottom: 157px; left: 156px; z-index: 1;
      width: 36px; height: 41px; background-size: cover;
    }
    .building-1 {
      bottom: 140px; left: 100px;
      width: 30px; height: 40px; background-size: cover;
      &.type-1 {
        left: 250px; bottom: 220px;
      }
    }
    .building-2 {
      bottom: 110px; left: 240px;
      width: 96px; height: 78px; background-size: cover;
    }
    .building-3 {
      bottom: 255px; left: 165px;
      width: 93px; height: 71px; background-size: cover;
    }
    .time-1 {
      bottom: 260px; left: 144px; z-index: 1;
      width: 29px; height: 35px; background-size: cover;
    }
    .time-2 {
      bottom: 220px; left: 214px; z-index: 0;
      width: 25px; height: 37px; background-size: cover;
    }
    ul {
      width: 185px; font-size: 10px;
      color: #fff; padding: 15px 0 15px 5px; border-radius: 20px;
      position: absolute; right: 15px; top: 150px; z-index: 1;
      li {
        line-height: 24px;
        span {
          padding: 0 5px;
        }
      }
    }

    h2.type-1 {
      position: absolute; padding: 0; right: 15px; top: 48px; z-index: 1;
      font-size: 27px; width: 185px;
      span {
        font-size: 10px;
      }
    }
    h2.type-2 {
      font-size: 27px; padding-left: 15px; padding-top: 400px;
      span {
        font-size: 10px;
      }
    }
    dl {
      margin: 0 0 10px 17px; padding: 0; position: relative; z-index: 2;
      dt {
        font-size: 11px; line-height: 20px; background-color: #49c0c4;
        border-radius: 10px; display: inline-block; color: #fff;
        padding: 0 10px; margin: 20px 0 4px 0;
      }
      dd {
        margin: 0; color: #222224; font-size: 10px; line-height: 19px;
        padding-left: 10px; position: relative;
        &::before {
          content: ''; position: absolute; width: 2px; height: 2px;
          background-color: #4ad4d9; border-radius: 100%; left: 0; top: 10px;
        }
      }
    }
  }
</style>

<template lang="pug">
  .ulivebus-container
    .in-sec
      h2.type-1 ULive Bus #[span 기업형 셔틀버스 솔루션]
      ul
        li #[span 01] LBS 위치처리 플랫폼 (집계 솔루션)
        li #[span 02] 실시간 차량관제 모니터링
        li #[span 03] 진입차량 운수사 차량 배차관리
        li #[span 04] 부정 승차 방지
        li #[span 05] NFC 방식의 사원증 태깅
        li #[span 06] 원격 펌웨어 업데이트
        li #[span 07] BIS 연계 정보 제공
        li #[span 08] 데이터 음영 지역 보안처리

      div.car.animate-8.slide-car(data-aos="fade")
      div.satellite
      div.signal-1
      div.signal-2
      div.signal-3

      h2.type-2 ULive Bus #[span 기업형 보안차량관리 솔루션]

      dl
        dt 통합관제 주요 기능
        dd 일 / 시간대별 차량 출입현황 통계 조회
        dd 현재 공장 내 실시간 차량 위치 정보 조회
        dd 차량별 차량 이동 경로 추적 조회
        dd 입차된 차량이 GPS 정보 누락 알림 (통신두절)
        dd 출입제한 차량 및 사용자 등록 관리
        dd 운전자에게 메시지 전파

      dl
        dt 승인처리
        dd 승인 처리 담당자 등록 관리
        dd 방문자 승인 요청 시 해당 담당자에게 이메일 전송
        dd 모바일을 통한 승인 처리 지원
        dd 승인처리 내역 조회 (운수사별 / 일자별)

      div.road
      div.line
      div.car-1
      div.sign

      div.time-1.animate-5.slide-down(data-aos="fade-in")
      div.time-2.animate-6.slide-down(data-aos="fade-in")

      div.building-1.animate-1.slide-down(data-aos="fade-in")
      div.building-1.type-1.animate-2.slide-down(data-aos="fade-in")
      div.building-2.animate-3.slide-down(data-aos="fade-in")
      div.building-3.animate-4.slide-down(data-aos="fade-in")
      media(:align="align", :visible="isDesktop", :mediaData="ulivebus")
</template>

<script>
import Media from '@/components/Media.vue';

export default {
  props: {
    ulivebus: {
      type: Object,
      default: null,
    },
  },
  components: {
    Media,
  },
  computed: {
    isDesktop() {
      if (!this.$mq) return false;
      if (this.$mq.resize && this.$mq.isDesktop()) return true;
      return false;
    },
  },
  data() {
    return {
      align: 'right',
    };
  },
};
</script>
